import React from "react";
import {Deviation} from "../dashboard";
import agent from "../../agent";
import DeviationItem from "./DeviationItem";
import {Header, Loader} from "semantic-ui-react";
import {GeneralTitleCase, getGeneralTitle} from "../../utils/common";
import localStyles from "./index.module.css";

interface Props {
}

interface State {
    loading: boolean,
    deviations: Deviation[];
}

class Deviations extends React.PureComponent<Props, State> {
    state: State = {
        loading: true,
        deviations: [],
    };

    async componentDidMount() {
        const deviations: Deviation[] = await agent.PatientProvider.getDeviationsList();

        this.setState({deviations: deviations, loading: false});
    };

    render() {
        const styles = localStyles;
        const headerLabel: string = `Отклонения`;

        return (
            <div className={styles.table}>
                {this.state.loading ?
                <Loader active/>
                :
                <div className={styles.header}>
                    <Header>{headerLabel}</Header>
                    {this.state.deviations.map((deviation)=>{
                        return <DeviationItem deviation={deviation} />
                    })}
                </div>}
            </div>
        )
    };
}

export default Deviations;
